// src/components/WalletConnect.js
import React, { useContext, useState } from 'react';
import { WalletContext } from '../contexts/WalletContext';

const WalletConnect = () => {
  const { 
    account, 
    balance, 
    connectWallet, 
    disconnectWallet, 
    isConnecting,
    error
  } = useContext(WalletContext);
  
  const [connectClicked, setConnectClicked] = useState(false);

  // Format address for display
  const formatAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };
  
  const handleConnect = async () => {
    setConnectClicked(true);
    console.log("Connect button clicked");
    try {
      await connectWallet();
    } catch (err) {
      console.error("Error in connectWallet:", err);
    } finally {
      // Reset state after a delay
      setTimeout(() => setConnectClicked(false), 3000);
    }
  };

  if (!account) {
    return (
      <div className="card">
        <h2>Connect Your Wallet</h2>
        <p>To interact with the platform, you need to connect a compatible wallet.</p>
        {error && <div className="alert alert-danger">{error}</div>}
        {connectClicked && !isConnecting && !error && (
          <div className="alert alert-warning">
            Please check your wallet for connection prompts...
          </div>
        )}
        <button 
          id="connect-wallet" 
          onClick={handleConnect}
          disabled={isConnecting}
          style={{
            backgroundColor: isConnecting ? '#cccccc' : '',
            cursor: isConnecting ? 'not-allowed' : 'pointer'
          }}
        >
          {isConnecting ? 'Connecting...' : 'Connect Wallet'}
        </button>
      </div>
    );
  }

  return (
    <div className="wallet-info">
      <div>
        <strong>Connected Wallet: </strong>
        <span id="wallet-address" className="address">{formatAddress(account)}</span>
      </div>
      <div>
        <strong>Balance: </strong>
        <span id="wallet-balance">{balance}</span> MONAD
      </div>
      <div>
        <button 
          id="disconnect-wallet" 
          className="btn-danger"
          onClick={disconnectWallet}
        >
          Disconnect
        </button>
      </div>
    </div>
  );
};

export default WalletConnect;